import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button } from "components/Button/Button"
import { CheckableButton } from "components/CheckableButton/CheckableButton"
import { EnumerationTypeSelect } from "components/EnumerationTypeSelect/EnumerationTypeSelect"
import { ModalForm } from "components/ModalForm/ModalForm"
import { SelectBox } from "components/Select/Select"
import { Textbox } from "components/Textbox/Textbox"
import { Toast } from "components/ToastShow/ToastAlert"
import { useEffect, useRef, useState } from "react"
import { MessageType } from "types/enum"
import { ICON_TYPE } from "utils/constants"
import { trans } from "utils/helpers"
import { getReport, postReport, removeReport, setAsDefaultReport } from "./api"
import "./style.scss"
import { ConditionFormatForm } from "./FormatCondition"


interface ButtonToolbarprint {
    onClick?: () => void,
    Callback: (id: any,dataFromConditionForm?:any) => void,
    objectTag?: string,
    reportDomain?: string,
    customBtn?:boolean
    openPrintFormatCondition?:boolean

}
export const ButtonPrintIcon=({  customBtn,Callback,openPrintFormatCondition=false,objectTag,reportDomain }:ButtonToolbarprint ) => {
    const buttonToolbarReportStarting = useRef<any>(null);
    const [showSubMenu, setShowSubMenu] = useState(false);
    const [options, setOptions] = useState<any>()
    const [selectoptions, setSelectOptions] = useState<any>()
    const [showCreateReport, setShowCreateReport] = useState<any>(false)
    const [reportName, setReportName] = useState<any>()
    const [reportPath, setReportPath] = useState<any>()
    const [scope, setScope] = useState<any>()
    const [selecetedPrintTemplate,setSelecetdPrintTemplate]=useState<any>(null)
const [showOpenPrintFormatCondition,setShowOpenPrintFormatCondition]=useState(false)

    const [loading, setLoading] = useState<any>()
    const conditionFormRef=useRef<any>()
    const [rotate , setRotate] = useState<boolean>(false);
    const [showOperations, setShowOperations] = useState(false);
    const formButton = useRef<any>();
    const showOperationsRef = useRef<any>(false);
    const formRef=useRef<any>()
    const boxRef=useRef<any>()



    function showSubMenuFunction() {
        setShowSubMenu(true)
    }
    async function sendDataAsync(data) {
        
        try {
           const res =  await postReport(data)
           let conditionFormRefData = null as any
           if(showOpenPrintFormatCondition){
           
            
      conditionFormRefData= {
      UseWarmSignature: conditionFormRef.current?.UseWarmSignature?.checked,
      ShowCompanyInfo: conditionFormRef.current?.ShowCompanyInfo?.checked,
      ShowCustomerCode: conditionFormRef.current?.ShowCustomerCode?.checked,
      ShowCustomerCredit: conditionFormRef.current?.ShowCustomerCredit?.checked,
      ShowHeader: conditionFormRef.current?.ShowHeader?.checked,
      ShowItemDescription: conditionFormRef.current?.ShowItemDescription?.checked,
      ShowDescription: conditionFormRef.current?.ShowDescription?.checked,
      ShowAddress: conditionFormRef.current?.ShowAddress?.checked,
      ShowPayments: conditionFormRef.current?.ShowPayments?.checked,
      ShowUnit1: conditionFormRef.current?.ShowUnit1?.checked,
      ShowUnit2: conditionFormRef.current?.ShowUnit2?.checked,
    };
           }
          

           
           Callback && Callback(res.Data+"Design",conditionFormRefData)
            setShowCreateReport(false)
            getDataAsync()
        } catch (error) {
            
        }


    }
   async function getDataAsync() {
       let option:any = []
       setRotate(true)
       setLoading(false)
    try {  
        if(objectTag){
            const res = await getReport(objectTag)
            if(res && !!Object.keys(res)?.length){
                Object.keys(res)?.map(item=>{             
                    option.push({Id:item,Name :res?.[item]?.Title })
                 })
            }
         }
         if(!openPrintFormatCondition){option.push({Id:"Design" ,Name :"create" }) }
         setLoading(true)
         setOptions(option)
    } catch (error) {
        let option:any = []
      if(!openPrintFormatCondition) {option.push({Id:"Design" ,Name :"create" })}
        setLoading(true)
        setOptions(option)
     }
        
    }

    function clickToCloseSubMenu(e){
            if(e.target.type != "button" && !e.target.closest('[name="showSubMenu"]')){
             setShowSubMenu(false)
             buttonToolbarReportStarting.current?.blur()
             showOperationsRef.current = false
             setShowOperations(false)
             document.removeEventListener("click" ,clickToCloseSubMenu)
            }
   }
   function hideSubMenuFunction(e) {
       document.addEventListener("click",clickToCloseSubMenu)
           
   }


    function selectboxValSetter(id,dataFromConditionForm=null) {  
        setSelectOptions(id)
        if(id != "Design"){

            Callback && Callback(id,dataFromConditionForm);


        }else{
            setShowCreateReport(true)
        }
           setShowSubMenu(false)
           if( buttonToolbarReportStarting.current){
        buttonToolbarReportStarting.current?.blur()}
        showOperationsRef.current = false
        setShowOperations(false)
    }
    async function removeReportAsync(id) {
        try {
        await removeReport(id)
        getDataAsync()
        } catch (error) {
            
        }
             showOperationsRef.current = false
        setShowOperations(false)
     if(buttonToolbarReportStarting.current) (buttonToolbarReportStarting.current as HTMLButtonElement)?.blur();
        setShowSubMenu(false)
    }
    async function setasdefault(id) {
        try {
        await setAsDefaultReport(id,objectTag)
        getDataAsync()
        } catch (error) {
            
        }
          showOperationsRef.current = false
        setShowOperations(false)
     if(buttonToolbarReportStarting.current) (buttonToolbarReportStarting.current as HTMLButtonElement)?.blur();
        setShowSubMenu(false)

    }

    

    function formSubmit(e){
        e.preventDefault()
        if(formRef.current.checkValidity()){
            let report=  {
                PrintTemplateName: reportName,
                // PrintTemplateNameEN:
                  PrintTemplateFileName:reportPath+".mrt",
                  objectTag: objectTag,
                  scope: +scope,
                  IsDefault:formRef.current?.IsDefault.checked
                }
             sendDataAsync(report);

        }else{
                formRef.current.reportValidity() 
        }
    }
    
    useEffect(() => {
        if(showSubMenu || true){

            getDataAsync()
        }
    }, [objectTag,showSubMenu]);
    return (

        <>  
        {(objectTag && !openPrintFormatCondition )&&
        <div className="" style={{width:"10px" , marginLeft:"5%"}}>
            <button name="showSubMenu" type="button" ref={buttonToolbarReportStarting} onClick={() => { }} onFocus={showSubMenuFunction} onBlur={hideSubMenuFunction} className="btn toolbar-btn mb-1  d-flex flex-column  justify-content-center align-items-center    " >
            {
                customBtn?
            <FontAwesomeIcon   style={{width:"20px" }} icon={[ICON_TYPE, "print"]} color="" size="lg" className="icon mt-1 " />
                
                :
                <FontAwesomeIcon  style={{width:"20px" , float:"left" ,marginLeft:`${customBtn?'0px':'20px'}`}} icon={[ICON_TYPE, "print"]} color="gray" size="lg" className="icon mt-1 " />

            }
            <div  className={`toolbar-btn-sub-menu mt-1 ${showSubMenu ? "" : "d-none"}`}>
                {loading ?
                <>
                   {options && options?.map((option, index) => (
                    <div  key={index} style={{display:"flex",cursor:"pointer" }} className="toolbar-btn-sub-menu__option" data-value={`${option.Id}`}  >
                       <div className="operations__trigger-btn noHover"  ref={formButton} onFocus={()=>{setShowOperations(option.Id);showOperationsRef.current = option.Id}} onClick={(e)=>{e.stopPropagation();}} style={{position:"relative",width: "20px" , paddingLeft:0  , marginRight: "-13px"  ,marginBottom: "4px"}} tabIndex={-1}    onBlur={() => { setShowOperations(false);showOperationsRef.current = false }}>
                           {option.Name!="create" &&  
                           <FontAwesomeIcon color="grey"   icon={[ICON_TYPE, "ellipsis-v"]} /> 
                           } 
                            {(showOperations ==option.Id ||showOperationsRef.current==option.Id)&& 
                            <div  style={{minWidth: "90px" ,left:`${buttonToolbarReportStarting.current?.getBoundingClientRect().left+20}px`, top: `${buttonToolbarReportStarting.current?.getBoundingClientRect().top+50}px` ,width:"120px",position:'fixed' }} className={`operations__operations-box pt-1 ${(showOperations==option.Id ||showOperationsRef.current==option.Id) ? "" : "d-none"}`}>
                              <div onClick={e=>{e.stopPropagation()  ; selectboxValSetter(option.Id+"Design")}} className={`operations__operations-icon-wrapper Hover`} >
                                 <div className="operations__operations-icon-wrapper " onClick={() => {  }}>
                                 <FontAwesomeIcon  className="chat__chatbox-reply-btn"  color={"grey"}  icon={['fas', 'edit']} />
                                     <p>{trans("edit")}</p>
                                 </div>
                               </div>
                              <div onClick={e=>{e.stopPropagation()  ;Toast(trans("msg_deleteconfirm"), MessageType.confirmDelete , ()=>{ removeReportAsync(option.Id)})}} className={`operations__operations-icon-wrapper `} >
                                 <div className="operations__operations-icon-wrapper" onClick={() =>{}}>
                                 <FontAwesomeIcon icon={['fas', 'trash']} className="chat__chatbox-reply-btn"   color={`${'grey'}`} />
                                     <p>{trans("Delete")}</p>
                                 </div>
                               </div>
                              <div onClick={e=>{e.stopPropagation()  ;setasdefault(option.Id)}} className={`operations__operations-icon-wrapper `} >
                                 <div className="operations__operations-icon-wrapper" onClick={() =>{}}>
                                 <FontAwesomeIcon icon={['fas', 'square-check']} className="chat__chatbox-reply-btn"   color={`${'grey'}`} />
                                     <p>{trans("setasdefault")}</p>
                                 </div>
                               </div>
                            
                            </div>
                            }
                        </div> 
                        <span className="mx-1 w-100 d-flex align-items-center"  onClick={()=>{selectboxValSetter(option.Id)}}> 
                        {trans(option.Name)}
                        </span> 
                    </div>
                   ))}
                </>
                :
                <div  className="sync-box-icon mt-4" onClick={()=>{setRotate(true);  setTimeout(()=>{ setRotate(false) }, 1500)}}   >       
                <FontAwesomeIcon icon={[ICON_TYPE , "sync"] } className={`text-primary  ${rotate ? "Rotate" : "" } `}  />  
                </div>  
            }
            </div>
            </button>
        </div>
        }
         {(objectTag && openPrintFormatCondition )&&
       <div className="" style={{width:"10px" , marginLeft:"5%"}}>
                                    <button type="button" ref={buttonToolbarReportStarting} onClick={() => { setShowOpenPrintFormatCondition(true)}}  className="btn toolbar-btn mb-1  d-flex flex-column  justify-content-center align-items-center    " >
            {
                customBtn?
            <FontAwesomeIcon   style={{width:"20px" }} icon={[ICON_TYPE, "print"]} color="" size="lg" className="icon mt-1 " />
                
                :
                <FontAwesomeIcon  style={{width:"20px" , float:"left" ,marginLeft:`${customBtn?'0px':'20px'}`}} icon={[ICON_TYPE, "print"]} color="gray" size="lg" className="icon mt-1 " />

            }
        <></>
            </button>
           {loading ?<ConditionFormatForm objectTag={objectTag} ref={conditionFormRef}  showOpenPrintFormatCondition={showOpenPrintFormatCondition}
            selecetedPrintTemplate={selecetedPrintTemplate}
            selectboxValSetter={selectboxValSetter}
            setasdefault={setasdefault}
          setShowOpenPrintFormatCondition={setShowOpenPrintFormatCondition}

   removeReportAsync={removeReportAsync}
            options={options}
            setSelecetdPrintTemplate={setSelecetdPrintTemplate}

            />:<></>}
       </div>
        }
        {showCreateReport &&
            <ModalForm mode={"create"} title={"PrintTemplate"} onHide={() => { setShowCreateReport(false) }} show={showCreateReport}>
                <form ref={formRef} className="Reserve-form py-2" >
                    <div className="card">
                <div className="card-body">
                    <div className="container">
                        <div className="row ">
                            <div className="col">
                                <Textbox  
                                required
                                    textboxType="text"
                                    textboxName="reportName"
                                    onChange={(e)=>{setReportName(e.target.value)}}
                                    defaultValue={""}
                                    labelText="PrintTemplateName"
                                    mode={"edit"}
                                />
                            </div>  
                            <div className="col">
                                 <Textbox  
                                 required
                                 textboxType="systemKey"
                                 textboxName="reportPath"
                                 onChange={(e)=>{setReportPath(e.target.value)}}
                                 defaultValue={""}
                                 labelText="PrintTemplateFileName"
                                 mode={"edit"}
                               />
                             </div>
                            <div className="col">
                                {/* DV */}
                                <EnumerationTypeSelect
                                onChange={setScope}
                                mode={"edit"}
                                label="scope"
                                enumTypeSelect="Scope" 
                                name="Scope"
                                value={null} />
                             </div>

                             <div className="col-12">
                                 <CheckableButton
                                    // defaultChecked={IsDefault}
                                    // defaultValue={IsDefault}
                                    labelText={"IsDefault"}
                                    inputName={"IsDefault"}
                                    type="checkbox"
                                    mode={'edit'}
                                                   />   
                             </div>
                        </div>
                        <div className="d-flex justify-content-end mt-4">
                            <>
                                <Button 
                                customClass="not-inherit"
                                
                            onClick={(e)=>{formSubmit(e)}}  value="Save" btnType="submit" />
                                <Button
                                customClass="not-inherit"
                                    btnType="cancel"
                                    value="Cancel"
                                    onClick={() => { setShowCreateReport(false) }}
                                />
                            </>
                        </div>
                    </div>
                 </div>
                    </div>
                </form>
                                    
            </ModalForm>
        }
        </>
    )
    }